import { Item as PhotoswipeItem } from 'photoswipe';
import { MouseEvent } from 'react';

import { ImageSwipe } from 'components/pages/ProductDetails/types/Imageswipe';
import { getDefaultOptions, updatePhotoswipeImages } from 'helpers/photoswipe';

type GetPhotoswipe = (args: {
  imageSwipe: ImageSwipe;
  setImageSwipe: (o: ImageSwipe) => void;
}) => {
  displayProductImage: (e: MouseEvent<HTMLElement>) => void;
  handleCarouselSlideChange: (idx: number) => void;
  handlePhotoSwipeOpen: (e: MouseEvent) => void;
};

export const getImageControls: GetPhotoswipe = ({ imageSwipe, setImageSwipe }) => {
  const displayProductImage = (e: MouseEvent<HTMLElement>): void => {
    e.preventDefault();
    const index = Number(e.currentTarget.dataset.imageIndex);
    setImageSwipe({
      ...imageSwipe,
      currentImageIndex: index,
    });
  };

  const handlePhotoSwipeOpen = (e: MouseEvent) => {
    e.preventDefault();

    // in transformImagesToPhotoswipe there is an event handler on image load, until it
    // fires and sets w & h props we shouldn't allow for opening zoom as the image will not be centered
    if (imageSwipe.images.filter((el: PhotoswipeItem) => !el.w || !el.h).length) {
      return;
    }
    setImageSwipe({
      ...imageSwipe,
      images: updatePhotoswipeImages(imageSwipe.images),
      isOpen: true,
      swipeOptions: getDefaultOptions(imageSwipe.currentImageIndex),
    });
  };

  const handleCarouselSlideChange = currentIndex => {
    setImageSwipe({
      ...imageSwipe,
      currentImageIndex: currentIndex,
    });
  };

  return { displayProductImage, handleCarouselSlideChange, handlePhotoSwipeOpen };
};
